<section class="connect-page">
    <mat-card class="connect-card">
        <mat-card-header>
            <div class="card-title-row">
                <p class="connect-section-title">Runs</p>
                <div class="actions">
                    <button color="accent" mat-stroked-button routerLink="/connect/workflows">Back</button>
                    <button (click)="loadRuns()" [disabled]="loading()" color="primary" mat-stroked-button>Refresh
                    </button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="filter-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Filter by workflow id (optional)</mat-label>
                    <input (input)="filterWorkflowId.set(($any($event.target).value || ''))" (keyup.enter)="loadRuns()" [value]="filterWorkflowId()"
                           matInput
                           type="text"/>
                </mat-form-field>
            </div>

            @if (error()) {
                <p class="connect-muted" role="alert">{{ error() }}</p>
            } @else if (loading()) {
                <div class="loading-row">
                    <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
                    <span class="connect-muted">Loading runs...</span>
                </div>
            } @else if (runs().length === 0) {
                <p class="connect-muted">No runs found.</p>
            } @else {
                <div class="table-wrap">
                    <table [dataSource]="runs()" class="runs-table" mat-table>
                        <ng-container matColumnDef="id">
                            <th *matHeaderCellDef mat-header-cell>Run</th>
                            <td *matCellDef="let run" mat-cell>
                                <span class="connect-pill">{{ run.id }}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="workflow">
                            <th *matHeaderCellDef mat-header-cell>Workflow</th>
                            <td *matCellDef="let run" mat-cell>{{ run.workflow_id }}</td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th *matHeaderCellDef mat-header-cell>Status</th>
                            <td *matCellDef="let run" mat-cell>
                                <span [ngClass]="statusClass(run.status)"
                                      class="connect-chip">{{ humanStatus(run.status) }}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="duration">
                            <th *matHeaderCellDef mat-header-cell>Duration</th>
                            <td *matCellDef="let run" mat-cell>{{ formatDuration(run) }}</td>
                        </ng-container>

                        <ng-container matColumnDef="created">
                            <th *matHeaderCellDef mat-header-cell>Created</th>
                            <td *matCellDef="let run" mat-cell>{{ run.created_at }}</td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th *matHeaderCellDef mat-header-cell>Actions</th>
                            <td *matCellDef="let run" class="actions-cell" mat-cell>
                                <button (click)="openRun(run)" color="primary" mat-button>Open</button>
                                <button (click)="rerun(run)" color="accent" mat-button>Rerun</button>
                            </td>
                        </ng-container>

                        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
                    </table>
                </div>
            }
        </mat-card-content>
    </mat-card>
</section>
